"use strict";

var Rating = new Class({
	Implements: [Options, Events],

	options: {},

	initialize: function initialize(_element, options) {
		if (!_element) return;

		this._element = _element;
		this.setOptions(options);
		this.build();
	},

	build: function build() {
		var self = this;
		var is_clicked = false;
		var onHint = false;

		if (self._element) {
			var _el = self._element.getElements(".w_rating_show, .w_rating_show_click_area") || document.getElement(".w_rating_show, .w_rating_show_click_area") || self._element;
			_el.addEvents({
				"click": function click() {
					if (!self._element.hasClass("_clicked")) {
						self.hideAll();

						self.show(self._element.getElementById(self._element.getAttribute("data-id")));

						self._element.addClass("_opened");
						self._element.addClass("_clicked");

						is_clicked = true;
					} else {
						self.hideAll();
					}
				}
			});

			var _close_btn = self._element.getElement('.w_rating_close_btn');

			if (_close_btn) {
				_close_btn.addEvent('click', function (e) {
					if (e && e.stop) {
						e.stop();
					}

					self.hide(self._element.getElementById(self._element.getAttribute("data-id")));

					self._element.removeClass('_opened');
					self._element.removeClass('_clicked');
					is_clicked = false;
				});
			}

			var _rating_hint = document.getElement('.w_rating_hint');
			if (_rating_hint) {
				_rating_hint.addEvents({
					'mouseenter': function mouseenter() {
						onHint = true;
					},
					'mouseleave': function mouseleave() {
						onHint = false;

						if (!self._element.hasClass('_clicked')) {
							self._element.removeClass('_opened');
						}
					}
				});
			}
		}

		var _slipper = self._element.getElement('.w_rating_hint .w_slipper'),
		    _active_points,
		    same = false;

		var _bounds = self._element.getElements('#architecture_points, #location_points, #features_points');

		if (_bounds && _bounds.length > 0) {
			_bounds.each(function (_el) {
				self.hide(_el);
			});
		}

		if (_slipper) {
			new Slipper(_slipper, {
				onElementClick: function onElementClick(_el) {
					if (_active_points) {
						same = _active_points.get('id') == _el.getAttribute('data-id');
					}

					if (_active_points && !same) {
						_active_points.hide().fade('hide');
					}

					if (!same) {
						var _points = _active_points = self._element.getElement('#' + _el.getAttribute('data-id'));
						_points.show().fade('in');
					}
				}
			});
		}
	},

	show: function show(_el) {
		if (_el) {
			_el.fade("in").show();
		}
	},

	hide: function hide(_el) {
		if (_el) {
			_el.fade("hide").hide();
		}
	},

	hideAll: function hideAll() {
		var self = this;
		var _elements = document.getElements(".w_rating._opened");
		if (_elements && _elements.length > 0) {
			_elements.each(function (element) {
				element.removeClass("_opened");
				element.removeClass("_clicked");
				self.hide(element.getElementById(element.getAttribute("data-id")));
			});
		}
	}
});
'use strict';

var Streetview = new Class({
	Implements: [Options, Events],

	options: {
		cls: "w_streetview",
		container: null,
		zoomControl: true
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);
		this._element = element;

		if (this._element) {
			Core.load_google_api(this.build.bind(this));
		}
	},

	build: function build() {
		var _self = this._element,
		    opts = this.options,
		    cls = opts.cls;

		this.mode = 'webgl';
		this.check_webgl();

		var _config = _self.getElement('.' + cls + '_config');
		var _pano = this._pano = _self.getElement('.' + cls + '_pano');

		if (_pano && _config) {
			var config = this.config = JSONMOO.decode(_config.get('text').toString().trim(), false);
			config.mode = this.mode;

			if (!config.position && config.lat && config.lng) {
				config.position = new google.maps.LatLng(config.lat, config.lng);
			}

			var default_config = {
				position: new google.maps.LatLng(40.7642676, -73.9741554),
				addressControl: false,
				scrollwheel: false,
				fullscreenControl: false,
				zoomControl: opts.zoomControl
			};

			var final_config = Object.merge(default_config, config);
			var service = this.service = new google.maps.StreetViewService();

			if (final_config.pov && Object.keys(final_config.pov).length) {
				this.init_pano(final_config);
			} else {
				var panoRequest = {
					location: final_config.position,
					preference: google.maps.StreetViewPreference.NEAREST,
					radius: final_config.radius || 50,
					source: google.maps.StreetViewSource.OUTDOOR
				};
				service.getPanorama(panoRequest, function (pano_data, status) {
					if (status == google.maps.StreetViewStatus.OK) {
						var angle = this.compute_angle(final_config.position, pano_data.location.latLng);

						final_config.pov = {
							'heading': angle,
							'pitch': 0,
							'zoom': 1,
							'pano_data': pano_data
						};
					} else {
						final_config.pov = null;
					}
					this.init_pano(final_config);
				}.bind(this));
			}
		}
	},

	check_webgl: function check_webgl() {
		var canvas = new Element('canvas'),
		    contextNames = ["webgl", "experimental-webgl", "moz-webgl", "webkit-3d"],
		    gl = null;

		contextNames.each(function (e, i) {
			if (!gl) {
				try {
					gl = canvas.getContext(contextNames[i]);
				} catch (e) {}
			}
		});

		canvas = null;

		if (gl === null) this.mode = 'html4';
	},

	init_pano: function init_pano(config) {
		if (config.pov.pano_data.location.pano) {
			config.pano = config.pov.pano_data.location.pano;
		}
		var pano = this.pano = new google.maps.StreetViewPanorama(this._pano, Object.merge(config, { visible: true }));

		var marker_config = {
			'position': config.position,
			'clickable': false,
			'map': pano
		};

		if (config.marker) {
			marker_config = Object.merge(marker_config, config.marker);
		}

		this.base_marker = new google.maps.Marker(marker_config);
	},

	compute_angle: function compute_angle(end, start) {
		var DEGREE_PER_RADIAN = 57.2957795;
		var RADIAN_PER_DEGREE = 0.017453;
		var dlat = end.lat() - start.lat();
		var dlng = end.lng() - start.lng();
		var angle = Math.atan2(dlng * Math.cos(end.lat() * RADIAN_PER_DEGREE), dlat) * DEGREE_PER_RADIAN;

		if (angle >= 360) {
			angle -= 360;
		} else if (angle < 0) {
			angle += 360;
		}
		return angle;
	}
});
'use strict';

var BlimpExtPricehistory = new Class({
	Extends: BlimpExt,

	post_process_build: function post_process_build() {
		var _table = this._element.getElement('.w_pricehistory_table') || this._element.getElement('.w_pricehistory_fullscreen_table');;
		var tbody = _table.getElement('.tbody');

		if (this.is_initialized) {
			return;
		}

		if (this.options.page === 'lst' || this.options.vscroll) {
			new StyledScroll(tbody, {
				type: 'v',
				max_height: 300
			});
		}

		var _diagram = this._element.getElement('.diagram');

		if (_diagram) {
			_diagram.setStyle('height', _table.getSize().y);

			var data = JSONMOO.decode(_diagram.get('html'), false);

			_diagram.set('html', '');

			new Phgraph(_diagram, {
				'size': 'small',
				'data': data.reverse() // need to reverse the order so it will be display properly in the chart
			});
		}

		this.parent();
		this.is_initialized = true;
	}

});
'use strict';

Page.Bdw = new Class({
	Extends: Page,
	build: function build() {
		this.parent();
		this.get_stalker_info();
		this.fill_nav_title();
		this.building_stalker_data();

		this.set_sales_data();
		this.set_available_apts();
		this.set_similar_buildings();
		this.set_floorplans();
		this.set_all_units();
		this.set_sell();
		this.set_contact();
		this.set_off_market_deals();

		//this.add_alert_link();

		this.add_ratings_support();
		this.bottom_bar();
		this.show_top_nav_contact();

		this.add_save_link();
		this.add_share_link();
	},

	show_top_nav_contact: function show_top_nav_contact() {
		var buttonContact = document.getElement('[data-popup-name="contact-popup"');
		var buttonContactTopNav = document.getElement('.button-contact-top');
		if (buttonContact && buttonContactTopNav) {
			buttonContactTopNav.removeClass('none');
		}
	},

	bottom_bar: function bottom_bar() {
		var triggerElement = document.getElement('.content');
		Core.bottom_bar(triggerElement, 150);
	},

	add_ratings_support: function add_ratings_support() {
		var _ratings = document.getElements(".w_rating._large, .w_rating.item");
		if (_ratings && _ratings.length > 0) {
			_ratings.each(function (rating) {
				new Rating(rating);
			});
		}
	},

	add_alert_link: function add_alert_link() {
		var _alertButton = document.getElement('.alert-button-container .building-alert');
		this._stalker_alert_link = document.getElement('.w_stalker .persist_nav.building .links-icons');
		if (this._stalker_alert_link && _alertButton) {
			_alertButton.inject(this._stalker_alert_link);
		}
	},

	get_stalker_info: function get_stalker_info() {
		var _info = document.getElement('.stalker_info');

		this.apt_sale = _info.getElement('input[name=apts_sale]').get("value");
		this.apt_rent = _info.getElement('input[name=apts_rent]').get("value");
		this.build_name = _info.getElement('input[name=build_name]').get("value");
		this.build_address = _info.getElement('input[name=build_address]').get("value");
		this.build_type = _info.getElement('input[name=build_type]').get("value").capitalize();
		this.build_predev_concept = _info.getElement('input[name=build_predev_concept]').get("value");
		this.map_link = _info.getElement('input[name=map_link]').get("value");
		this.map_name = _info.getElement('input[name=map_name]').get("value");
		this.apt_sale_url = _info.getElement('input[name=apts_sale_url]').get("value");
		this.bldg_full_url = _info.getElement('input[name=bldg_full_url]').get("value");
		this.all_units_url = _info.getElement('input[name=all_units_url]').get("value");
		this.similar_buildings_url = _info.getElement('input[name=similar_buildings_url]').get("value");
		this.sales_history_url = _info.getElement('input[name=sales_history_url]').get("value");
		this.is_sales_history = _info.getElement('input[name=is_sales_history]').get("value");
		this.floorplans_url = _info.getElement('input[name=floorplans_url]') ? _info.getElement('input[name=floorplans_url]').get("value") : '';
		this.sell_url = _info.getElement('input[name=sell_url]') ? _info.getElement('input[name=sell_url]').get("value") : '';
		this.building_total_units = _info.getElement('input[name=building_total_units]') ? _info.getElement('input[name=building_total_units]').get("value") : '0';
	},
	building_stalker_data: function building_stalker_data() {
		var _info = document.getElement('.stalker_info');
		var building_stalker = document.getElement('.persist_nav.building');
		var building_name = _info.getElement('input[name="build_name"]').value;
		var building_address = _info.getElement('input[name="build_address"]').value;

		// Doorman?
		var is_doorman = _info.getElement('input[name="is_doorman"]').value;

		// Sales history removal
		var is_sales_history = _info.getElement('input[name="is_sales_history"]').value;
		if (!is_sales_history) {
			building_stalker.getElement('.sale-history').remove();
		}

		// Ratings removal
		var is_ratings = _info.getElement('input[name="is_ratings"]').value;
		if (!is_ratings) {
			building_stalker.getElement('.ratings').remove();
		}

		var build_type = _info.getElement('input[name=build_type]').value.capitalize();
		var build_hood = _info.getElement('input[name=map_name]').value;
		if (building_name) {
			building_stalker.getElement('.title').set('text', building_name + ', ' + building_address);
		} else {
			building_stalker.getElement('.title').set('text', building_address);
		}
		building_stalker.getElement('.bldg-type').set('text', (is_doorman ? 'Doorman ' : '') + build_type + ' in ' + build_hood);

		var apts_sale = document.getElement('input[name="apts_sale"]').value;
		var apts_rent = document.getElement('input[name="apts_rent"]').value;
		var apts_num = apts_sale + apts_rent;
	},
	fill_nav_title: function fill_nav_title() {
		var _stalker_title = document.getElement('.w_stalker .nav_title');

		var building_stalker = document.getElement('.persist_nav.building');
		var _info = document.getElement('.stalker_info');
		var is_doorman = _info.getElement('input[name="is_doorman"]').value;
		var build_type = _info.getElement('input[name=build_type]').value.capitalize();
		var build_hood = _info.getElement('input[name=map_name]').value;
		building_stalker.getElement('.bldg-type').set('text', (is_doorman ? 'Doorman ' : '') + build_type + ' in ' + build_hood);

		// links
		var navItems = document.querySelectorAll('.building_nav ul li');
		var bldgFullUrl = document.querySelector('input[name="bldg_full_url"]').value;

		navItems.forEach(function (item) {
			item.addEventListener('click', function () {
				var targetId = this.getAttribute('data-target');
				if (targetId) {
					var fullUrlWithHash = bldgFullUrl + '#' + targetId;
					// redirect to hash
					window.location.href = fullUrlWithHash;
				}
			});
		});

		if (!_stalker_title) {
			return;
		}

		var _stalker_info = _stalker_title.getElement('._info');
		var _stalker_build_type = _stalker_title.getElement('._type');
		// var _stalker_map_link = _stalker_title.getElement('._map');

		// var _stalker_build_name = _stalker_title.getElement('._name');
		// check the building name
		// if (this.build_name === ''){
		// 	this.build_name = this.build_address;
		// 	_stalker_build_name.set('text', this.build_name);
		// } else {
		// 	// check the address
		// 	if (this.build_address === '') {
		// 		_stalker_build_name.set('text', this.build_name);
		// 	} else {
		// 		_stalker_build_name.set('text', this.build_name + ', ' + this.build_address);
		// 	}
		// }

		var buildingTypeAndHood = void 0;
		if (this.build_type != '') {
			buildingTypeAndHood = this.build_type;
		}
		if (this.map_name != '') {
			if (this.build_type != '') {
				buildingTypeAndHood += ' in ';
			}
			buildingTypeAndHood += this.map_name;
		}
		_stalker_build_type.set('text', buildingTypeAndHood);
	},

	set_off_market_deals: function set_off_market_deals() {
		var _off_market_deals = document.getElement('.w_stalker ._info .button-off-market-deals');

		if (_off_market_deals) {
			if (this.build_predev_concept == "0" && (this.build_type === 'Condo' || this.build_type === 'Co-Op' || this.build_type === 'Condop')) {
				// nothing to do
			} else {
				_off_market_deals.getParent().dispose();
			}
		}
	},

	set_available_apts: function set_available_apts() {
		var apts = this.apt_sale.toInt() + this.apt_rent.toInt();
		var _aval_apts = document.getElement('.w_stalker ._info ._aval_apts');

		if (apts > 0 && _aval_apts && _aval_apts.getElement('._value')) {
			_aval_apts.getElement('._value').set('text', apts);
			_aval_apts.getElement('._text').set('text', 'Available Apt' + (apts > 1 ? 's' : ''));
			_aval_apts.set('href', this.apt_sale_url);
		} else if (_aval_apts) {
			_aval_apts.getParent().dispose();
		}
	},

	set_sales_data: function set_sales_data() {
		var _sales_history = document.getElement('.w_stalker ._info ._sales_history');

		if (_sales_history && this.is_sales_history === '1') {
			_sales_history.set('href', this.sales_history_url);
		} else if (_sales_history) {
			_sales_history.getParent().dispose();
		}
	},

	set_similar_buildings: function set_similar_buildings() {
		var apts = this.apt_sale.toInt() + this.apt_rent.toInt();
		var _similar_buildings = document.getElement('.w_stalker ._info ._similar_buildings');

		if (_similar_buildings) {
			_similar_buildings.set('href', this.similar_buildings_url);
		} else if (_similar_buildings) {
			_similar_buildings.getParent().dispose();
		}
	},

	set_all_units: function set_all_units() {
		var apts = this.apt_sale.toInt() + this.apt_rent.toInt();
		var _all_units = document.getElement('.w_stalker ._info ._all_units');

		if (_all_units && this.all_units_url && this.build_predev_concept == "0") {
			_all_units.set('href', this.all_units_url);
		} else if (_all_units) {
			_all_units.getParent().dispose();
		}
	},

	set_floorplans: function set_floorplans() {
		// var apts = this.apt_sale.toInt() + this.apt_rent.toInt();
		// var _floorplans = document.getElement('.w_stalker ._info ._floorplans');

		// if (_floorplans && this.floorplans_url) {
		// 	_floorplans.set('href', this.floorplans_url);
		// } else {
		// 	_floorplans.getParent().dispose();
		// }
	},

	set_sell: function set_sell() {
		var _sell = document.getElement('.w_stalker ._info ._sell');

		if (_sell) {
			if (_sell && this.sell_url && this.build_type !== 'No Fee Rental' && this.build_type !== 'Townhouse') {
				_sell.set('href', this.sell_url);
				Core.setBuildingSellData(_sell, this.building_total_units);
			} else {
				_sell.getParent().dispose();
			}
		}
	},

	set_contact: function set_contact() {
		var _contact = document.getElement('.w_stalker ._info .button-book-tour');

		if (_contact && this.build_type === 'No Fee Rental') {
			_contact.set('text', 'Contact');
		}
	},

	add_save_link: function add_save_link() {
		var _alertButton = document.querySelector('.bov_info .building-alert');
		this._stalker_alert_link = document.querySelector('.w_stalker .persist_nav.building .other-icons');
		if (this._stalker_alert_link && _alertButton) {
			this._stalker_alert_link.appendChild(_alertButton);
		}
	},

	add_share_link: function add_share_link() {
		var _shareButton = document.querySelector('.bov_info .link-icon.email');
		this._stalker_alert_link = document.querySelector('.w_stalker .persist_nav.building .other-icons');
		if (this._stalker_alert_link && _shareButton) {
			this._stalker_alert_link.appendChild(_shareButton);
		}
	}

});
//# sourceMappingURL=bdw.js.map
